import React from "react";
import { Button, Row } from "sunflowers";
import "./TypeSelect.scss";
export const TypeSelect = (props) => {
    return (React.createElement(Row, { flex: true, className: `TypeSelect ${props.className}` },
        props.label && React.createElement("p", null, props.label),
        React.createElement("ul", null, props.buttons.map((button, i) => (React.createElement("li", { key: i },
            React.createElement(Button, { name: button.name, outlined: true, active: props.active === button.value, onClick: () => props.onChange(button.value) })))))));
};
